import { Checkbox, FormControl, Grid, SelectChangeEvent } from '@mui/material';
import { Fragment, memo, useCallback, useEffect, useMemo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import { useEventCallback } from '@mui/material';
import { DatePicker } from '@mui/lab';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { ItemVM } from 'shell/view-models/item';
import ListTypeRequest from '../list/list-type-request';
import ListAnsc from '../../../../../../shared/list-ansc';
import { IDChangeSurname } from 'civil-status/constants/id-change-surname';
import { IDSentenceRecognition } from 'civil-status/constants/id-sentence-recognition';
import { ID_OTHER_PLACE } from 'civil-status/constants/id-other-place';
import FormTratxtBase from './form-tratxt-base';
import Foreign from '../../shared/foreign';
import { ForeignForm } from 'civil-status/view-models/accordion-generality-form';
import Italian from '../../shared/italian';
import { ItalianForm } from 'shell/view-models/italian-form';
import { RadioGroup } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { Radio } from '@mui/material';
import { IDTypeRequest } from 'civil-status/constants/id-type-request';
import { ID_APPLICANT } from 'civil-status/constants/id-applicant';
import ListNumber from '../list/list-number';

interface TranscriptionDataProps {
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  controllSentenceRecognitionNameSurname: (sentenceRecognition?: string) => void;
  controllApplicant: (applicant?: string) => void;
  controllIsReceivedPrivateCitizen: (isReceivedPrivateCitizen?: boolean) => void;
  controllTypeApplicant: (typeApplicant?: string) => void;
  controllNumberHolders: (numberHolders?: string) => void;
  controllNumberChildren: (numberChildren?: string) => void;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  configuration?: string;
  tipoEvento?: string;
  idEvento?: number;
  idUseCase?: string;
  disabled?: boolean;
}

const TranscriptionDataComponent = ({
  onChange,
  onChanges,
  controllSentenceRecognitionNameSurname,
  controllApplicant,
  controllIsReceivedPrivateCitizen,
  controllTypeApplicant,
  controllNumberHolders,
  controllNumberChildren,
  values,
  errors,
  touched,
  configuration,
  tipoEvento,
  idEvento,
  disabled = false,
  idUseCase,
}: TranscriptionDataProps): React.ReactElement => {
  const isTrastxtRic = useMemo(() => {
    return configuration === ConfigurationType.TRASTXTRIC;
  }, [configuration]);

  const isTratxBasr = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASR;
  }, [configuration]);

  const isTratxBasrn = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASRN;
  }, [configuration]);

  const isTratxBasrq = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASRQ;
  }, [configuration]);

  const isTratxBasrx = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASRX;
  }, [configuration]);

  const isTratxBasro = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASRO;
  }, [configuration]);

  const isTratxTBasf = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASF;
  }, [configuration]);

  const isTrasNaslu = useMemo(() => {
    return configuration === ConfigurationType.TRASNASLU;
  }, [configuration]);

  const isTratxtBaseC = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASC;
  }, [configuration]);

  const isTratxBasS = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASS;
  }, [configuration]);

  const isTratxBasC = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASC;
  }, [configuration]);

  const isTratxBasD = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASD;
  }, [configuration]);

  const isTratxBasQ = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASQ;
  }, [configuration]);

  const isTratxBasF = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASF;
  }, [configuration]);

  const isTrascritIsc = useMemo(() => {
    return configuration === ConfigurationType.TRASCRTISC;
  }, [configuration]);

  const isTratxtTisc = useMemo(() => {
    return configuration === ConfigurationType.TRATXTTISC;
  }, [configuration]);

  const isTratxtBasn = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASN;
  }, [configuration]);

  const isTratxBasrp = useMemo(() => {
    return configuration === ConfigurationType.TRATXBASRP;
  }, [configuration]);

  const isTratxtBasv = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASV;
  }, [configuration]);

  const isTratxtBasg = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASG;
  }, [configuration]);

  const isTratxtBasi = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBASI;
  }, [configuration]);

  const isTratxtUce = useMemo(() => {
    return configuration === ConfigurationType.TRATXTUCE;
  }, [configuration]);

  const isTratxtUc2 = useMemo(() => {
    return configuration === ConfigurationType.TRATXTUC2;
  }, [configuration]);

  const isTratxtUc3 = useMemo(() => {
    return configuration === ConfigurationType.TRATXTUC3;
  }, [configuration]);

  const isTratxtMte = useMemo(() => {
    return configuration === ConfigurationType.TRATXTMTE;
  }, [configuration]);

  const isTratxtMtae = useMemo(() => {
    return configuration === ConfigurationType.TRATXTMTAE;
  }, [configuration]);

  const isTratxtBsde = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBSDE;
  }, [configuration]);

  const isTratxtBsdf = useMemo(() => {
    return configuration === ConfigurationType.TRATXTBSDF;
  }, [configuration]);

  const isTraneGass = useMemo(() => {
    return configuration === ConfigurationType.TRANEGASS;
  }, [configuration]);

  const handleListSentenceRecognition = useEventCallback((item?: ItemVM) => {
    onChange('sentenceRecognition', item?.id);
  });

  useEffect(() => {
    if (isTratxtBasg) {
      controllSentenceRecognitionNameSurname(values?.sentenceRecognition);
    }
  }, [values?.sentenceRecognition, isTratxtBasg]);

  useEffect(() => {
    if (isTratxtBsde || isTratxtBsdf) {
      controllIsReceivedPrivateCitizen(values?.isReceivedPrivateCitizen);
    }
  }, [values?.isReceivedPrivateCitizen, isTratxtBsde, isTratxtBsdf]);

  useEffect(() => {
    if (isTratxBasrp) {
      controllTypeApplicant(values?.typeApplicant);
    }
  }, [values?.typeApplicant, isTratxBasrp]);

  useEffect(() => {
    if (isTratxBasrp) {
      controllNumberHolders(values?.numberHolders);
    }
  }, [values?.numberHolders, isTratxBasrp]);

  useEffect(() => {
    if (isTratxBasrq || isTratxBasrx) {
      controllNumberChildren(values?.numberChildren);
    }
  }, [values?.numberChildren, isTratxBasrq, isTratxBasrx]);

  useEffect(() => {
    if (!values?.applicant?.id) {
      return;
    }

    controllApplicant(values?.applicant?.id?.toString());
  }, [values?.applicant]);

  const handleListApplicant = useEventCallback((value?: ItemVM) => {
    onChange('applicant', value);
  });

  const handleListTypeApplicant = useEventCallback((value?: ItemVM) => {
    onChange('typeApplicant', value?.id);
  });

  const handleListTypeRequest = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('typeRequest', event.target.value);
  });

  const handleListTypeBirthPlace = useEventCallback((item?: ItemVM) => {
    onChange('typeBirthPlace', item?.id);
  });

  const handleListChangeSurname = useEventCallback((item?: ItemVM) => {
    onChanges({
      changeSurname: item?.id?.toString() || '',
      newName: '',
      newSurname: '',
      nameAdded: '',
      surnameAdded: '',
    });
  });

  const handleListTypeDisappearance = useEventCallback((item?: ItemVM) => {
    onChange('typeDisappearance', item?.id);
  });

  const handleListTypeActToTranscribed = useEventCallback((item?: ItemVM) => {
    onChange('typeActToTranscribed', item?.id);
  });

  const handleListTypeModificationMarriage = useEventCallback((item?: ItemVM) => {
    onChange('typeModificationMarriage', item?.id);
  });

  const handleListNumberChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('numberHolders', event.target.value);
  });

  const handleListNumberChildrenChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('numberChildren', event.target.value);
  });

  const onFieldForeignChange = useCallback(
    (key, value) => {
      onChanges({
        ...(values || {}),
        foreign: {
          ...(values || {}).foreign,
          [key]: value,
        },
      });
    },
    [values, onChanges]
  );

  const onFieldsForeignChange = useCallback(
    (valuesNew) => {
      onChanges({
        ...(values || {}),
        foreign: {
          ...(valuesNew || {}),
        },
      });
    },
    [values, onChange]
  );

  const onChangeItalian = useCallback(
    (key, value) => {
      onChange('italian', {
        ...(values || {}).italian,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onChangesItalian = useCallback(
    (valuesNew) => {
      onChange('italian', {
        ...(values || {}).italian,
        ...valuesNew,
      });
    },
    [values, onChange]
  );

  const labelData: string = useMemo(() => {
    if (isTratxtBsde || isTratxtBsdf) {
      return 'Data comunicazione *';
    }

    if (isTratxBasr || isTratxBasrn || isTratxBasrq || isTratxBasrx || isTratxBasro) {
      return 'Data richiesta *';
    }

    if (isTraneGass) {
      return 'Data accordo *';
    }

    // obbligatorio se tipo richiesta === IDTypeRequest.Scritta
    const isNotRequiredFromTypeRequest =
      isTratxtUce || isTratxtUc2 ? values?.typeRequest !== IDTypeRequest.Scritta : false;

    return `Data richiesta trascrizione ${
      isTratxtMtae || isTratxtUc3 || isNotRequiredFromTypeRequest ? '' : '*'
    }`;
  }, [
    isTratxtBsde,
    isTratxtBsdf,
    isTratxBasr,
    isTratxBasrn,
    isTratxBasrq,
    isTratxBasrx,
    isTratxBasro,
    isTratxtMtae,
    isTratxtUce,
    isTratxtUc2,
    isTratxtUc3,
    isTraneGass,
    values?.typeRequest,
    configuration,
  ]);

  const labelText: string = useMemo(() => {
    if (isTratxBasr || isTratxBasrn || isTratxBasrq || isTratxBasrx || isTratxBasro) {
      return 'Testo libero *';
    }

    if (isTratxBasQ || isTratxtBsde || isTratxtBsdf) {
      return 'Riassunto *';
    }

    return "Testo dell'atto da trascrivere *";
  }, [
    isTratxBasr,
    isTratxBasrn,
    isTratxBasrq,
    isTratxBasrx,
    isTratxBasro,
    isTratxBasQ,
    isTratxtBsde,
    isTratxtBsdf,
    configuration,
  ]);

  return (
    <Grid container spacing={2} item>
      {isTratxtMte || isTratxtMtae ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data evento matrimonio *"
            aria-label="Data evento matrimonio"
            value={values?.dateEvent || null}
            onChange={(date) => {
              onChange('dateEvent', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateEvent"
                fullWidth
                helperText={errors?.dateEvent}
                error={touched?.dateEvent && Boolean(errors?.dateEvent)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      {isTratxtUce || isTratxtUc3 ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data unione civile *"
            aria-label="Data unione civile"
            value={values?.dataCivilUnion || null}
            onChange={(date) => {
              onChange('dataCivilUnion', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dataCivilUnion"
                fullWidth
                helperText={errors?.dataCivilUnion}
                error={touched?.dataCivilUnion && Boolean(errors?.dataCivilUnion)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      {isTratxtUce || isTratxtUc2 || isTratxtUc3 ? (
        <Grid item xs={12} md={6}>
          <ListAnsc
            label="Tipo atto da trascrivere"
            idDominio="55"
            value={values?.typeActToTranscribed || ''}
            onChange={handleListTypeActToTranscribed}
            error={Boolean(errors?.typeActToTranscribed) && touched?.typeActToTranscribed}
            required
          />
        </Grid>
      ) : undefined}
      {isTratxtMte || isTratxtMtae ? (
        <Fragment>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                aria-label="Stato"
                id="isForeign"
                value={values?.isForeign || 'false'}
                onChange={() => {
                  onChanges({
                    ...(values || {}),
                    isForeign: !values?.isForeign,
                    italian: {
                      location: '',
                      province: '',
                      municipality: null,
                    },
                    foreign: {
                      state: null,
                      province: '',
                      municipality: null,
                    },
                  });
                }}
              >
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="Italia"
                  disabled={disabled}
                />
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Estero"
                  disabled={disabled}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {values?.isForeign ? (
            <Fragment>
              <Foreign
                disabledComponent={disabled}
                values={values?.foreign}
                onChange={onFieldForeignChange}
                onChanges={onFieldsForeignChange}
                errors={errors?.foreign as FormikErrors<ForeignForm>}
                touched={touched?.foreign as unknown as FormikTouched<ForeignForm>}
                labelState="Stato"
                required
                isWithLocationForeign
              />
            </Fragment>
          ) : (
            <Italian
              disabledComponent={disabled}
              values={values?.italian}
              onChange={onChangeItalian}
              onChanges={onChangesItalian}
              errors={errors?.italian as FormikErrors<ItalianForm>}
              touched={touched?.italian as unknown as FormikTouched<ItalianForm>}
              labelMunicipality="Comune ente"
              labelProvince="Provincia ente"
              required
              fromDate={values?.dataCivilUnion || values?.dateEvent || null}
            />
          )}
        </Fragment>
      ) : undefined}
      {isTratxBasrn || isTratxBasrq || isTratxBasrx || isTratxBasro ? (
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={12} md={6}>
            <ListAnsc
              label="Tipo cambio nome"
              idDominio="39"
              value={values?.changeSurname || ''}
              onChange={handleListChangeSurname}
              disabled={disabled}
              error={Boolean(errors?.changeSurname) && touched?.changeSurname}
              required
              betweenFrom={6}
              betweenTo={10}
            />
          </Grid>
        </Grid>
      ) : undefined}
      {values?.changeSurname || isTratxtBasn || isTratxBasrp || isTratxtBasv || isTratxTBasf ? (
        <Grid item xs={12} container spacing={2}>
          {values?.changeSurname === IDChangeSurname.nuovoNome ||
          values?.changeSurname === IDChangeSurname.nuovoCognomeNome ||
          isTratxtBasn ||
          isTratxTBasf ||
          isTratxtBasv ? (
            <Grid item xs={12} md={6}>
              <PmiTextField
                label={`Nuovo nome ${isTratxtBasn || isTratxTBasf || isTratxtBasv ? '' : '*'}`}
                aria-label="Nuovo nome"
                id="newName"
                name="newName"
                fullWidth
                type="text"
                variant="outlined"
                value={values?.newName || ''}
                onChange={(event) => {
                  onChange('newName', event.target.value);
                }}
                error={touched?.newName && Boolean(errors?.newName)}
                helperText={errors?.newName}
                disabled={disabled}
              />
            </Grid>
          ) : undefined}
          {values?.changeSurname === IDChangeSurname.nuovoCognome ||
          values?.changeSurname === IDChangeSurname.nuovoCognomeNome ||
          isTratxtBasn ||
          isTratxBasrp ||
          isTratxtBasv ||
          isTratxTBasf ? (
            <Grid item xs={12} md={6}>
              <PmiTextField
                label={`Nuovo cognome ${isTratxTBasf ? '' : '*'}`}
                aria-label="Nuovo cognome"
                id="newSurname"
                name="newSurname"
                fullWidth
                type="text"
                variant="outlined"
                value={values?.newSurname || ''}
                onChange={(event) => {
                  onChange('newSurname', event.target.value);
                }}
                error={touched?.newSurname && Boolean(errors?.newSurname)}
                helperText={errors?.newSurname}
                disabled={disabled}
              />
            </Grid>
          ) : undefined}
          {values?.changeSurname === IDChangeSurname.nomeAggiunto ? (
            <Grid item xs={12} md={6}>
              <PmiTextField
                label="Nome aggiunto *"
                aria-label="Nome aggiunto"
                id="nameAdded"
                name="nameAdded"
                fullWidth
                type="text"
                variant="outlined"
                value={values?.nameAdded || ''}
                onChange={(event) => {
                  onChange('nameAdded', event.target.value);
                }}
                error={touched?.nameAdded && Boolean(errors?.nameAdded)}
                helperText={errors?.nameAdded}
                disabled={disabled}
              />
            </Grid>
          ) : undefined}
          {values?.changeSurname === IDChangeSurname.cognomeAggiunto ? (
            <Grid item xs={12} md={6}>
              <PmiTextField
                label="Cognome aggiunto *"
                aria-label="Cognome aggiunto"
                id="surnameAdded"
                name="surnameAdded"
                fullWidth
                type="text"
                variant="outlined"
                value={values?.surnameAdded || ''}
                onChange={(event) => {
                  onChange('surnameAdded', event.target.value);
                }}
                error={touched?.surnameAdded && Boolean(errors?.surnameAdded)}
                helperText={errors?.surnameAdded}
                disabled={disabled}
              />
            </Grid>
          ) : undefined}
        </Grid>
      ) : undefined}
      {isTratxBasrq || isTratxBasrx ? (
        <Grid item xs={12} md={4}>
          <ListNumber
            label="Numero Figli"
            value={values?.numberChildren || ''}
            onChange={handleListNumberChildrenChange}
            disabled={disabled}
            error={Boolean(errors?.numberChildren) && touched?.numberChildren}
            required
            isNumber20
          />
        </Grid>
      ) : undefined}
      {isTratxBasrp ? (
        <Fragment>
          <Grid item xs={12} md={4}>
            <ListAnsc
              label="Tipo richiedente"
              idDominio="117"
              value={values?.typeApplicant || ''}
              onChange={handleListTypeApplicant}
              disabled={disabled}
              error={Boolean(errors?.typeApplicant) && touched?.typeApplicant}
              required
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListNumber
              label="Numero intestatari"
              value={values?.numberHolders || ''}
              onChange={handleListNumberChange}
              disabled={disabled}
              error={Boolean(errors?.numberHolders) && touched?.numberHolders}
              required
              isNumber20
            />
          </Grid>
        </Fragment>
      ) : undefined}
      {isTratxBasF ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data passaggio in giudicato sentenza *"
            aria-label="Data passaggio in giudicato sentenza"
            value={values?.dateMarriage || null}
            onChange={(date) => {
              onChange('dateMarriage', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateMarriage"
                fullWidth
                helperText={errors?.dateMarriage}
                error={touched?.dateMarriage && Boolean(errors?.dateMarriage)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      {isTratxBasS || isTratxBasQ || isTratxBasD ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label={
              isTratxBasQ ? 'Data esito accertamento Ministero *' : 'Data esito accertamento *'
            }
            aria-label={
              isTratxBasQ ? 'Data esito accertamento Ministero' : 'Data esito accertamento'
            }
            value={values?.dateOutcomeVerification || null}
            onChange={(date) => {
              onChange('dateOutcomeVerification', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateOutcomeVerification"
                fullWidth
                helperText={errors?.dateOutcomeVerification}
                error={touched?.dateOutcomeVerification && Boolean(errors?.dateOutcomeVerification)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      {isTratxBasS || isTratxBasD || isTratxBasC ? (
        <Grid item xs={12} md={8}>
          <PmiTextField
            label="Esito accertamento *"
            aria-label="Esito accertamento"
            id="assessmentResult"
            name="assessmentResult"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.assessmentResult || ''}
            onChange={(event) => {
              onChange('assessmentResult', event.target.value);
            }}
            error={touched?.assessmentResult && Boolean(errors?.assessmentResult)}
            helperText={errors?.assessmentResult}
            disabled={disabled}
          />
        </Grid>
      ) : undefined}
      {isTrastxtRic || isTratxBasrn || isTratxBasrq || isTratxtBasv ? (
        <Grid item xs={12} md={4}>
          <ListAnsc
            label={
              isTratxBasrn || isTratxBasrq || isTratxtBasv ? 'Tipo richiedente' : 'Richiedente'
            }
            idDominio="64"
            value={values?.applicant?.id?.toString() || ''}
            onChange={handleListApplicant}
            disabled={disabled}
            error={Boolean(errors?.applicant) && touched?.applicant}
            required
            withoutId={isTrastxtRic ? [ID_APPLICANT.MADRE_PADRE] : undefined}
            onlyId={isTratxBasrq ? [ID_APPLICANT.SOGGETTO, ID_APPLICANT.ALTRO] : undefined}
          />
        </Grid>
      ) : undefined}
      {isTrastxtRic ||
      isTratxBasr ||
      isTratxBasrn ||
      isTratxBasrq ||
      isTratxBasrx ||
      isTratxBasro ||
      isTratxtBasv ||
      isTratxtUce ||
      isTratxtUc2 ||
      isTratxtUc3 ||
      isTratxtMte ||
      isTratxtBsde ||
      isTratxtBsdf ? (
        <Grid item xs={12} md={4}>
          <ListTypeRequest
            value={values?.typeRequest || ''}
            onChange={handleListTypeRequest}
            disabled={disabled}
            error={Boolean(errors?.typeRequest) && touched?.typeRequest}
            required
          />
        </Grid>
      ) : undefined}
      {isTrasNaslu ? (
        <Fragment>
          <Grid item xs={12} md={4}>
            <ListAnsc
              label="Tipo luogo di nascita"
              idDominio="41"
              value={values?.typeBirthPlace || ''}
              onChange={handleListTypeBirthPlace}
              disabled={disabled}
              error={Boolean(errors?.typeBirthPlace) && touched?.typeBirthPlace}
              required
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <PmiTextField
              label={`Descrizione luogo di nascita ${
                values?.typeBirthPlace === ID_OTHER_PLACE ? '*' : ''
              }`}
              aria-label="Descrizione luogo di nascita"
              id="Descrizione luogo di nascita"
              name="Descrizione luogo di nascita"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.descriptionBirthPlace || ''}
              onChange={(event) => {
                onChange('descriptionBirthPlace', event.target.value);
              }}
              error={
                touched?.descriptionBirthPlace &&
                Boolean(errors?.descriptionBirthPlace) &&
                values?.typeBirthPlace === ID_OTHER_PLACE
              }
              helperText={errors?.descriptionBirthPlace}
              disabled={disabled}
            />
          </Grid>
        </Fragment>
      ) : undefined}
      {isTratxtBaseC ? (
        <Grid item xs={12} md={4}>
          <DatePicker
            label="Data matrimonio con cittadino italiano *"
            aria-label="Data matrimonio con cittadino italiano"
            value={values?.dateMarriage || null}
            onChange={(date) => {
              onChange('dateMarriage', date);
            }}
            disabled={disabled}
            renderInput={(params) => (
              <PmiTextField
                {...params}
                id="dateMarriage"
                fullWidth
                helperText={errors?.dateMarriage}
                error={touched?.dateMarriage && Boolean(errors?.dateMarriage)}
              />
            )}
          />
        </Grid>
      ) : undefined}
      {isTratxtBasi ? (
        <Grid item xs={12} md={8}>
          <PmiTextField
            label="Nome istituto minore abbandonato *"
            aria-label="Nome istituto minore abbandonato"
            id="nameInstituteAbandonedMinor"
            name="nameInstituteAbandonedMinor"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.nameInstituteAbandonedMinor || ''}
            onChange={(event) => {
              onChange('nameInstituteAbandonedMinor', event.target.value);
            }}
            error={
              touched?.nameInstituteAbandonedMinor && Boolean(errors?.nameInstituteAbandonedMinor)
            }
            helperText={errors?.nameInstituteAbandonedMinor}
            disabled={disabled}
          />
        </Grid>
      ) : undefined}
      {isTratxtBasg ? (
        <Grid item xs={12} md={6}>
          <ListAnsc
            label="Tipo dichiarazione giudiziale"
            idDominio="98"
            value={values?.sentenceRecognition || ''}
            onChange={handleListSentenceRecognition}
            disabled={disabled}
            error={Boolean(errors?.sentenceRecognition) && touched?.sentenceRecognition}
            required
            betweenFrom={Number.parseInt(IDSentenceRecognition.Riconoscimento1, 10)}
            betweenTo={Number.parseInt(IDSentenceRecognition.Riconoscimento2, 10)}
          />
        </Grid>
      ) : undefined}
      {isTrascritIsc || isTratxtTisc ? (
        <Grid item xs={12} md={6}>
          <ListAnsc
            label="Tipo di scomparsa"
            idDominio="59"
            value={values?.typeDisappearance || ''}
            onChange={handleListTypeDisappearance}
            disabled={disabled}
            error={Boolean(errors?.typeDisappearance) && touched?.typeDisappearance}
            required
          />
        </Grid>
      ) : undefined}
      {isTratxBasD ? (
        <Grid item xs={12}>
          <PmiTextField
            label="Riassunto della dichiarazione *"
            aria-label="Riassunto della dichiarazione *"
            id="summaryStatement"
            name="summaryStatement"
            fullWidth
            type="text"
            variant="outlined"
            value={values?.summaryStatement || ''}
            onChange={(event) => {
              onChange('summaryStatement', event.target.value);
            }}
            error={touched?.summaryStatement && Boolean(errors?.summaryStatement)}
            helperText={errors?.summaryStatement}
            disabled={disabled}
          />
        </Grid>
      ) : undefined}
      {isTratxtBsde || isTratxtBsdf ? (
        <Grid item xs={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="isReceivedPrivateCitizen"
                checked={values?.isReceivedPrivateCitizen || false}
                onChange={() => {
                  onChange('isReceivedPrivateCitizen', !values?.isReceivedPrivateCitizen);
                }}
                inputProps={{ 'aria-label': 'Ricevuta da privato cittadino' }}
              />
            }
            label="Ricevuta da privato cittadino"
          />
        </Grid>
      ) : undefined}
      {isTratxtBsdf ? (
        <Grid item xs={12} md={6}>
          <ListAnsc
            label="Tipo modifica al matrimonio"
            idDominio="54"
            value={values?.typeModificationMarriage || ''}
            onChange={handleListTypeModificationMarriage}
            disabled={disabled}
            error={Boolean(errors?.typeModificationMarriage) && touched?.typeModificationMarriage}
            required
          />
        </Grid>
      ) : undefined}
      <FormTratxtBase
        onChange={onChange}
        onChanges={onChanges}
        values={values}
        errors={errors}
        touched={touched}
        tipoEvento={tipoEvento}
        idUseCase={idUseCase}
        idEvento={idEvento}
        disabled={disabled}
        labelData={labelData}
        labelText={labelText}
        isTraneGass={isTraneGass}
      />
    </Grid>
  );
};

TranscriptionDataComponent.displayName = 'Form Transcription Data component';

const TranscriptionData = memo(TranscriptionDataComponent);

export default TranscriptionData;
